/**
 * Petunjuk SEKALI-PAKAI "Geser untuk produk berikutnya" di foto terakhir
 * galeri produk. Fitur geser ke produk lain tak terlihat sampai dicoba, jadi
 * pembeli diberi tahu satu kali per perangkat; sesudahnya pil "Berikutnya ›"
 * di foto terakhir sudah cukup sebagai pengingat.
 *
 * Keluarga kunci `galea-*` = fitur storefront per-perangkat (sekeluarga
 * dengan `galea-preorder-recent` milik "Terakhir Dilihat").
 */

export const FEED_HINT_KEY = "galea-product-feed-hint";

/** Nilai tersimpan → sudah pernah dilihat? Murni, diuji di Vitest. */
export function feedHintSeenFromStored(raw: string | null): boolean {
  return raw === "1";
}

/**
 * Sudah pernah melihat petunjuk? Storage tak terbaca (mode privat, kuota)
 * dianggap SUDAH: petunjuk yang tak bisa diingat akan muncul di setiap produk,
 * dan itu lebih mengganggu daripada tak pernah muncul.
 */
export function readFeedHintSeen(): boolean {
  if (typeof window === "undefined") return true;
  try {
    return feedHintSeenFromStored(window.localStorage.getItem(FEED_HINT_KEY));
  } catch {
    return true;
  }
}

/** Tandai petunjuk sudah dilihat; best-effort, tak pernah throw. */
export function markFeedHintSeen(): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(FEED_HINT_KEY, "1");
  } catch {
    // abaikan — fitur opsional
  }
}
